/** Shared helpers for gate × hour scan visualizations. */

/** Prefer daytime window when scan activity sits there; else full day. */
export function resolveHeatmapHours(hours = [], gates = []) {
  const hasDaytime = gates.some((gate) =>
    (gate.byHour || []).some((n, i) => i >= 6 && i <= 22 && Number(n) > 0)
  );
  if (!hasDaytime) return hours;
  return hours.filter((h) => h >= 6 && h <= 22);
}

export function formatHeatmapHour(hour) {
  return `${String(hour).padStart(2, '0')}:00`;
}
